"use strict";
// import { hexToNumber, numberToHex } from "../../utils/index.js";
// import { ethAddress } from "@opentron/tron-eth-conversions/index.js";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
// Queris a @opentron/tron-lgos-index server (e.g. http://logs.opentron.org/status)
function logsApiGetLogs([filterObject], ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        const { tronLogsClient: client } = ctx;
        const { data } = yield client.post("/logs", filterObject);
        return data;
    });
}
exports.default = logsApiGetLogs;
